import React, { useState } from 'react'
import CategoryList from './categoryList'
import AddCategory from './AddCategory'
import BackLogo from '../../../../../images/rewampimages/Chevron.png'
import SubcategoryMain from './Subcategory/Main'
export default function Main({ pageViewHandler }) {
    const [tab, setTab] = useState("list")
    const [data, setData] = useState({})
    const handleTab = (type, d) => {
        setData(d)
        setTimeout(() => { setTab(type) }, 0)
    }

    const handleBackbtn = (e) => {
        if (tab === "list") {
            pageViewHandler(e, 'landingPage')
        } else {
            handleTab("list")
        }
    }
    return (
        <>
            <div className="container-fluid">
                {
                    tab !== "details" ?
                        <div onClick={(e) => handleBackbtn(e)} style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                            <h5 style={{ cursor: 'pointer' }}>Back</h5>
                        </div>
                        : ''}
                {
                    tab === "list" ?
                        <CategoryList
                            handleTab={handleTab}
                        />
                        : ''
                }
                {
                    tab === "addcategory" ?
                        <AddCategory
                            handleTab={handleTab}
                            Detaildata={data}
                        />
                        : ''
                }
                {
                    tab === "details" ?
                        <SubcategoryMain
                            handleTab={handleTab}
                            data={data}
                        />
                        : ''
                }
            </div>
        </>
    )
}
